import { render, staticRenderFns } from "./Sift.vue?vue&type=template&id=2bf50d34&scoped=true&"
import script from "./Sift.vue?vue&type=script&lang=js&"
export * from "./Sift.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf50d34",
  null
  
)

export default component.exports